import BulkCreateAction from "../../actions/BulkCreateAction.js";
import GroupLinkCreator from './GroupLinkCreator.js';
import GroupRouteCreator from "./GroupRouteCreator.js";
export default (molten, cxt) => {
  const {
    relationship,
    isRoot
  } = cxt;
  const linkActionId = `link.${relationship.path}.GroupScreen`;
  const routeId = `route.${relationship.path}.GroupScreen`;
  molten.addPlugin('Action', GroupLinkCreator({
    id: linkActionId,
    relationship,
    isRoot
  }));
  molten.addPlugin('Route', GroupRouteCreator({
    id: routeId,
    relationship,
    isRoot
  }));
  if (relationship.opts.bulkCreate) {
    molten.addPlugin('Action', BulkCreateAction.create(relationship));
  }
};